import React from 'react';
import {
  ButtonApprove,
  FieldCheckBox,
  FieldInput,
  FieldTextArea,
  FormCol,
  FormRow,
  useIsFieldRequiredHook,
  FormCol1,
  FormCol3,
  FormCol6,
  EmptyFormRow,
} from 'motion-components';
import { useFormikContext } from 'formik';
import { useRootStore } from 'store';
import { useHandleError } from 'shared-pages/services';
import { useTranslation } from 'react-i18next';
import { dateField, isActiveField } from 'shared-pages/common/form-helpfunc';
import { Col, Row } from 'react-bootstrap';
import { FileRepoField } from 'shared-pages/components/filerepo-field';
import { FileRepoImage } from 'shared-pages/components/filerepo-image';
import {
  FieldSelectCollector,
  FieldSelectNomos,
  FieldSelectRegion,
  FieldSelectSubregion,
  FieldSelectTaxoffice,
  FieldSelectWasteDestinationType,
  FieldSelectWasteReceptionPoint,
} from 'shared-pages/components';
import {
  isRebattery,
  isAfisCyprus,
  isFotokiklosi,
  isMedicycle,
  CompanyVatTitle,
} from 'shared-pages/common/constants';
import { IdocWasteDestinationTypes } from 'shared-pages/shared/constants';

import { PostalCodeAutocomplete } from '../../../components/field-select/postal-code-autocomplete';

export const FormFields = ({
  isNew,
  updateRecord,
  refetch,
  data,
  handleApprove,
  validationSchema = undefined,
  canEdit,
}) => {
  //
  const frmkCntx = useFormikContext();
  const { values } = frmkCntx;
  const { authStore, appStore } = useRootStore();
  const { handleGraphqlError } = useHandleError('PiBaseFormFields');
  const { t } = useTranslation();
  const isFieldRequired = useIsFieldRequiredHook(validationSchema);

  return (
    <>
      <div>
        {/* <FieldSelectWasteDestinationType
          required={true}
          disabled={false}
          as={FormCol}
          name="wasteDestinationTypeId"
          defaultValues={data}
        /> */}
        <FormRow>
          <FieldInput
            as={FormCol}
            label={t('Επωνυμία Εταιρείας')}
            name="name"
            placeholder=""
            disabled={!canEdit}
            required={isFieldRequired('name', values)}
          />
          <FieldInput
            as={FormCol}
            label={t('Υπεύθυνος')}
            name="contactperson"
            placeholder=""
            disabled={!canEdit}
          />
          <FieldInput
            as={FormCol}
            label={t('Α.Μ. ΗΜΑ')}
            name="imaCode"
            placeholder=""
            disabled={!canEdit}
          />
          {isActiveField(t, canEdit, FormCol)}
        </FormRow>

        <FormRow>
          <FormCol>
            <FieldInput
              as={'div'}
              label={t('Διεύθυνση')}
              name="addressLine1"
              placeholder=""
              disabled={!canEdit}
              required={isFieldRequired('addressLine1', values)}
            />
            <FieldInput
              as={'div'}
              label={t('Διεύθυνση - 2η γραμμή')}
              name="addressLine2"
              placeholder=""
              disabled={!canEdit}
            />
          </FormCol>
          <FormCol>
            <FieldInput
              as={'div'}
              label={t('Τηλέφωνο')}
              name="phone"
              placeholder=""
              disabled={!canEdit}
            />
            <FieldInput
              as={'div'}
              label={t('Κινητό')}
              name="mobile"
              placeholder=""
              disabled={!canEdit}
            />
          </FormCol>

          <FieldTextArea
            as={FormCol}
            disabled={!canEdit}
            label={t('Παρατηρήσεις')}
            name="notes"
            type="text"
            rows={5}
            placeholder={t('')}
            required={false}
          />

          <FieldSelectCollector
            as={FormCol}
            name="collectorId"
            label={t('Συλλέκτης')}
            disabled={!canEdit}
          />
        </FormRow>

        <FormRow>
          <FieldInput
            as={FormCol}
            label={t('Περιοχή')}
            name="addressArea"
            placeholder=""
            disabled={!canEdit}
          />
          <FieldInput
            as={FormCol}
            label={t('E-mail')}
            name="email"
            placeholder=""
            disabled={!canEdit}
          />
          {appStore.isPlatformOwner && (
            <FormCol>
              <FieldCheckBox
                className="w-100"
                disabled={true}
                label={
                  data?.wasteDestinationTypeId === IdocWasteDestinationTypes.Recycling
                    ? t('Εγκεκριμένος Ανακυκλωτής')
                    : t('Εγκεκριμένη Δευτερογενής Αποθήκευση')
                }
                name="isApproved"
                onLabel={t('ΝΑΙ')}
                offLabel={t('ΟΧΙ')}
              />
            </FormCol>
          )}
        </FormRow>

        <FormRow>
          <FieldInput
            as={FormCol}
            label={t('Πόλη')}
            name="addressCity"
            placeholder=""
            disabled={!canEdit}
          />
          <FieldInput
            as={FormCol}
            label={CompanyVatTitle}
            name="companyVat"
            placeholder=""
            disabled={!canEdit}
            required={isFieldRequired('companyVat', values)}
          />
          {appStore.isPlatformOwner && (
            <FormCol3>
              <Row>
                <FieldInput
                  as={FormCol6}
                  label={t('Έγκριθηκε από')}
                  name="approvedBy"
                  disabled={true}
                />
                {dateField(t('Ημ/νία Έγκρισης'), 'approvedDate', t, false, FormCol6)}
              </Row>
            </FormCol3>
          )}
        </FormRow>

        <FormRow>
          {isFotokiklosi ? (
            <FormCol>
              <PostalCodeAutocomplete
                name="postalCode"
                label={t('T.K. :')}
                disabled={!canEdit}
                initialData={data}
                mTop={0}
              />
            </FormCol>
          ) : (
            <FieldInput
              as={FormCol}
              label={t('T.K.')}
              name="postalCode"
              placeholder=""
              disabled={!canEdit}
            />
          )}
          {!isAfisCyprus &&
            !isMedicycle &&
            (isFotokiklosi ? (
              <FieldSelectTaxoffice
                disabled={!canEdit}
                required={isFieldRequired('companyTaxOffice', values)}
                as={FormCol}
              />
            ) : (
              <FieldInput
                label={t('Δ.Ο.Υ.')}
                name="companyTaxOffice"
                placeholder=""
                disabled={!canEdit}
                required={isFieldRequired('companyTaxOffice', values)}
                as={FormCol}
              />
            ))}

          <FormCol className="d-flex align-items-center">
            {data?.isApproved === false && appStore.isPlatformOwner && (
              <ButtonApprove
                onClick={() => handleApprove()}
                text={t('Έγκριση')}
                className="col-12"
              />
            )}
          </FormCol>
        </FormRow>
        <FormRow>
          <FieldSelectRegion
            as={FormCol}
            name={'regionId'}
            defaultValues={{ data }}
            disabled={!canEdit}
          />
          <FieldSelectSubregion
            as={FormCol}
            name={'subregionId'}
            defaultValues={{ data }}
            disabled={!canEdit}
          />
          <FieldSelectNomos
            as={FormCol}
            name={'addressNomos'}
            defaultValues={{ data }}
            disabled={!canEdit}
          />
        </FormRow>
        <FormRow>
          <FieldInput
            as={FormCol}
            label={t('ERP Κωδικός')}
            name="erpId"
            placeholder=""
            disabled={!canEdit}
          />
        </FormRow>
        <hr className="mb-5" />
        <FormRow>
          {!isRebattery && (
            <FieldInput
              as={FormCol}
              label={t('Αριθμός Σύμβασης')}
              name="contractNo"
              placeholder=""
              disabled={!canEdit}
            />
          )}
          {dateField(t('Ημερομηνία Υπογραφής Σύμβασης'), 'contractSignDate', t, canEdit, FormCol)}
          {dateField(t('Λήξη Σύμβασης'), 'contractExpDate', t, canEdit, FormCol)}
        </FormRow>
        <FormRow>
          <FieldInput
            as={FormCol}
            label={t('Αρ. Πρωτ. / ΑΔΑ ΑΕΠΟ')}
            name="aepoNumber"
            placeholder=""
            disabled={!canEdit}
          />

          {dateField(t('Ημ/νία Λήξης ΑΕΠΟ'), 'aepoExpDate', t, canEdit, FormCol)}

          <FormCol>
            <Row style={{ margin: 0, marginBottom: '-15px' }}>
              <FileRepoField
                as={Col}
                label={t(
                  'Ανάρτηση ΑΕΠΟ ή Αποδεικτικού Εγγράφου Κατάθεσης Τροποποίησης/Ανανέωσης ΑΕΠΟ',
                )}
                fileIdFieldName="aepoFileId"
                fileRec={data?.aepoFilesrepository}
              />
              <FileRepoImage fileId={data?.aepoFilesrepository?.id} height="64px" />
            </Row>
          </FormCol>
        </FormRow>
        {data?.wasteDestinationTypeId === IdocWasteDestinationTypes.Recycling && (
          <>
            <FormRow>
              <FieldInput
                as={FormCol}
                label={t('Αρ. Πρωτ. / ΑΔΑ Άδειας Λειουργίας')}
                name="hazardousWastePermit"
                placeholder=""
                disabled={!canEdit}
              />

              <FormCol>
                <Row style={{ margin: 0, marginBottom: '-15px' }}>
                  <FileRepoField
                    as={Col}
                    label={t('Ανάρτηση Άδειας Λειτουργίας')}
                    fileIdFieldName="hazardousWastePermitFileId"
                    fileRec={data?.hazardousWastePermitFilesrepository}
                  />
                  <FileRepoImage
                    fileId={data?.hazardousWastePermitFilesrepository?.id}
                    height="64px"
                  />
                </Row>
              </FormCol>
            </FormRow>
            <FormRow>
              <FieldInput
                as={FormCol}
                label={t('Αρ. Γνωστοποίησης Λειτουργίας')}
                name="operationNumber"
                placeholder=""
                disabled={!canEdit}
              />

              <FormCol>
                <Row style={{ margin: 0, marginBottom: '-15px' }}>
                  <FileRepoField
                    as={Col}
                    label={t('Ανάρτηση Γνωστοποίησης Λειτουργίας')}
                    fileIdFieldName="operationFileId"
                    fileRec={data?.operationFilesrepository}
                  />
                  <FileRepoImage fileId={data?.operationFilesrepository?.id} height="64px" />
                </Row>
              </FormCol>
            </FormRow>
          </>
        )}

        <FormRow>
          <FieldInput
            as={FormCol}
            label={t('Αριθμός Ασφαλιστηρίου Αστικής Ευθύνης')}
            name="insurancePolicyNumber"
            placeholder=""
            disabled={!canEdit}
          />
          {dateField(
            t('Λήξη Ασφαλιστηρίου Αστικής Ευθύνης'),
            'insuranceExpirationDate',
            t,
            canEdit,
            FormCol,
          )}

          <FormCol>
            <Row style={{ margin: 0, marginBottom: '-15px' }}>
              <FileRepoField
                as={Col}
                label={t('Ανάρτηση Ασφαλιστηρίου Αστικής Ευθύνης')}
                fileIdFieldName="insuranceFileId"
                fileRec={data?.insuranceFilesrepository}
              />
              <FileRepoImage fileId={data?.insuranceFilesrepository?.id} height="64px" />
            </Row>
          </FormCol>
        </FormRow>

        <FormRow>
          {dateField(t('Λήξη ISO 14001:2015'), 'isoExpirationDate', t, canEdit, FormCol)}
          {dateField(
            t('Επόμενη Επιθεώρηση ISO 14001:2015'),
            'nextIsoAuditDate',
            t,
            canEdit,
            FormCol,
          )}

          <FormCol>
            <Row style={{ margin: 0, marginBottom: '-15px' }}>
              <FileRepoField
                as={Col}
                label={t('Ανάρτηση Πιστοποιητικού Επιθεώρησης ISO 14001:2015')}
                fileIdFieldName="isoFileId"
                fileRec={data?.isoFilesrepository}
              />
              <FileRepoImage fileId={data?.isoFilesrepository?.id} height="64px" />
            </Row>
          </FormCol>
        </FormRow>
      </div>
    </>
  );
};

const FormCol12 = (props) => (
  <Col sm={12} lg={12} xl={12} {...props}>
    {props.children}
  </Col>
);
